module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/testingLeftBottomBg-4567a345af5a9b7be35bb494fe930825.png";